import m1 from '../images/m113.jfif'
import m2 from '../images/m114.jfif'
import m3 from '../images/m115.jfif'
import m5 from '../images/m117.jfif'
import m6 from '../images/m118.jfif'
import m7 from '../images/m119.jfif'
import m8 from '../images/m129.jfif'
import m9 from '../images/m121.jfif'
import m10 from '../images/m122.jfif'
import m11 from '../images/m123.jfif'
import m12 from '../images/m124.jfif'
import m13 from '../images/m125.jfif'

import m14 from '../images/m126.jfif'
import m15 from '../images/m127.jfif'
import m16 from '../images/m128.jfif'
import m4 from '../images/m130.jfif'


console.log(3+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4+4)
const data7=[
    {
        id:1,
        img1:m1,
        img2:m2,
        img3:m3,
        img4:m4,


    },
    {
        id:2,

        img1:m5,
        img2:m6,
        img3:m7,
        img4:m8,


    },
    {
        id:3,

        img1:m9,
        img2:m10,
        img3:m11,
        img4:m12,


    },
    {
        id:4,
        img1:m13,
        img3:m15,
        img4:m16,
        img2:m14,
       
        


    }
]
export default data7